import React from 'react';
import { Chip } from '@mui/material';

type Severity = 'CRITICAL' | 'MAJOR' | 'MINOR' | 'OK';

interface Props {
  severity: Severity | string;
  size?: 'small' | 'medium';
}

const COLORS: Record<string, { color: string; bg: string }> = {
  CRITICAL: { color: '#ff3344', bg: 'rgba(255,51,68,0.12)' },
  MAJOR:    { color: '#ffb000', bg: 'rgba(255,176,0,0.12)' },
  MINOR:    { color: '#00ffff', bg: 'rgba(0,255,255,0.10)' },
  OK:       { color: '#00ff41', bg: 'rgba(0,255,65,0.12)' },
};

const SeverityChip: React.FC<Props> = ({ severity, size = 'small' }) => {
  const c = COLORS[severity] || { color: '#5aaa5a', bg: 'transparent' };
  return (
    <Chip
      label={severity}
      size={size}
      sx={{
        fontFamily: "'Press Start 2P', monospace",
        fontSize: '8px',
        color: c.color,
        backgroundColor: c.bg,
        border: `1px solid ${c.color}`,
        borderRadius: 0,
        textShadow: `0 0 6px ${c.color}80`,
      }}
    />
  );
};

export default SeverityChip;
